import React, { Component } from 'react'
import Radium, { StyleRoot } from 'proofpoint-radium'
import _ from 'lodash'
import Frame from 'react-frame-component'
import { Button } from 'reactstrap'
import { Helmet } from 'react-helmet'
import { MdDesktopWindows, MdTablet, MdSmartphone } from 'react-icons/md'

import CoreRenderFunction from 'containers/TemplateEditor/core/render'

class RendererView extends Component {
  state = { 
    width: '100%',
    viewScale: 1
  }

  componentDidMount = () => {
    this.handleResize()
    window.addEventListener( 'resize', this.handleResize )
  }

  componentDidUpdate = ( pp, ps ) => {
    if( this.state.width !== ps.width ){
      this.handleResize()
    }
  }

  handleResize = () => {
    if( document.getElementById( 'editor-section-renderer-container' ) ){
      let tmpFrameWidth = parseInt( this.state.width === '100%' ? '1200px' : this.state.width )
      let tmpContainerWidth = document.getElementById( 'editor-section-renderer-container' ).getBoundingClientRect().width
      if( tmpFrameWidth > tmpContainerWidth ){
        this.setState({ viewScale: tmpContainerWidth / tmpFrameWidth })
      } else {
        this.setState({ viewScale: 1 })
      }
    } else {
      this.setState({ viewScale: 1 })
    }
  }
  
  render = () => {
    let {
      selectedSection,
      languages,
      selectedLanguageShortname,
      onUpdateCarouselPage,
      carouselPage,
      selectedContainer,
      selectedEditableComponent,
      onChangeSectionEditorState,
      onStopDragComponent,
      hoveredComponentId
    } = this.props

    return (
      <>
        <div className="d-flex align-items-center">
          <Button 
            color={ this.state.width === '100%' ? 'primary' : 'light' }
            style={{ marginLeft: 'auto' }}
            onClick={ () => this.setState({ width: '100%' }) }>
            <MdDesktopWindows style={{ fontSize: '24px' }} />
          </Button>
          <Button 
            color={ this.state.width === '768px' ? 'primary' : 'light' }
            onClick={ () => this.setState({ width: '768px' }) }>
            <MdTablet style={{ fontSize: '24px' }} />
          </Button>
          <Button 
            color={ this.state.width === '450px' ? 'primary' : 'light' }
            onClick={ () => this.setState({ width: '450px' }) }>
            <MdSmartphone style={{ fontSize: '24px' }} />
          </Button>
        </div>
        <div id='editor-section-renderer-container'>
          <Frame
            id={ 'editor-section-renderer' }
            style={{
              width: this.state.width,
              minWidth: this.state.width === '100%' && '1200px',
              height: `${ 70 / this.state.viewScale }vh`,
              transform: `scale(${ this.state.viewScale })`,
              transformOrigin: "top left"
            }}
            initialContent={ '<!DOCTYPE html><html><head><link href="/bootstrap.css" rel="stylesheet"></link><link href="/fontawesome/css/all.min.css" rel="stylesheet"></link><link href="/image-block-styles.css" rel="stylesheet"></link></head><body style="overflow-y:scroll;overflow-x:hidden;"><div></div></body></html>' }>
            <StyleRoot>
              <div
                style={{
                  width: '100%',
                  height: '100%'
                }}>
                <style>{`.left-right-animated-button:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #252525; transition: 0.4s; }  .left-right-animated-button:hover:after { width: 100%; } \n.left-right-animated-button:hover div { color: #ffffff !important; }  \n\n.left-right-reverse-animated-button:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; }  \n.left-right-reverse-animated-button:hover:after { width: 100%; } \n.left-right-reverse-animated-button:hover div { color: #252525 !important; } \n\n.left-right-animated-button-v2:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #252525; transition: 0.4s; } \n.left-right-animated-button-v2:hover:after { width: 100%; }\n\n.left-right-reverse-animated-button-v2:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; } \n.left-right-reverse-animated-button-v2:hover:after { width: 100%; }\n\n.border-top-animated-button:before { content: ''; display: block; position: absolute; top: 100%; left: 0; width: 100%; height: 2px; transform: scale(0.85); background: #252525; transition: all 0.3s ease; }\n.border-top-animated-button:hover:before { transform: scale(1); } \n.border-top-animated-button:after { content: ''; display: block; position: absolute; top: 100%; left: 0; width: 100%; height: 2px; transform: scale(0.85); background: #252525; transition: all 0.3s ease; }\n.border-top-animated-button:hover:after { transform: scale(1); top: 0; } \n \n.animated-important-button:before { content: ''; background-color: #ad0a0a; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.animated-important-button:hover:before { width: 100%; }\n\n.outline-animated-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #808080; transition: 0.4s; }\n.outline-animated-button:hover:before { opacity: 1; transform: scale(1); }\n\n.outline-animated-secondary-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #808080; transition: 0.4s; }\n.outline-animated-secondary-button:hover:before { opacity: 1; transform: scale(1); }\n\n.slant-animated-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(0.5,1); background-color: #efefef; transition: 0.4s; } \n.slant-animated-button:hover:before { opacity: 1; transform: scale(1); }\n\n.slant-animated-primary-button:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(0.5,1); background-color: #454545; transition: 0.4s; } \n.slant-animated-primary-button:hover:before { opacity: 1; transform: scale(1); }`}</style>
                <CoreRenderFunction
                  item={ selectedSection }
                  languages={ languages }
                  selectedLanguageShortname={ selectedLanguageShortname }
                  mode={ 'edit' }
                  onUpdateCarouselPage={ onUpdateCarouselPage }
                  carouselPage={ carouselPage }
                  selectedContainer={ selectedContainer }
                  onChangeSectionEditorState={ onChangeSectionEditorState }
                  selectedEditableComponent={ selectedEditableComponent }
                  onStopDragComponent={ onStopDragComponent }
                  hoveredComponentId={ hoveredComponentId } />
              </div>
            </StyleRoot>
          </Frame>
        </div>
      </>
    )
  }
}

export default Radium( RendererView )